import { useMutation } from '@tanstack/react-query';
import { navigate } from 'gatsby';

async function postForm(formData) {
  const response = await fetch('/api/send-book-form', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return { status: response.status, data };
}

function useFormSender({ setPageStep, numberOfTries, setNumberOfTries }) {
  const mutation = useMutation({
    mutationFn: postForm,
    onSuccess({ status }) {
      if (status === 200) {
        navigate('/aws-konyv-magyarul-koszonjuk');
      } else if (status === 401) {
        setNumberOfTries((prev) => prev + 1);
        if (numberOfTries < 2) {
          setPageStep('showSmsVerification');
        } else {
          setPageStep('fatalError');
        }
      } else {
        setPageStep('fatalError');
      }
    },
    onError(error) {
      console.error('Network or server error:', error);
      setPageStep('fatalError');
    },
  });

  return {
    send(data) {
      mutation.mutate(data);
    },
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
  };
}

export default useFormSender;
